export function validatePassword(pw: string): string | null {
  if (pw.length < 8) return 'Password must be at least 8 characters'
  if (!/[A-Z]/.test(pw)) return 'Password must contain at least one uppercase letter (A–Z)'
  if (!/[a-z]/.test(pw)) return 'Password must contain at least one lowercase letter (a–z)'
  if (!/[0-9]/.test(pw)) return 'Password must contain at least one number (0–9)'
  return null
}
